export default "<p>control-timepicker works!</p>\n"